import { Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import ScanForm from "./pages/ScanForm";
import Controle from "./pages/Controle";
import Suivi from "./pages/Suivi";
import AuthGate from "./AuthGate";

function App() {
  const scan = (
    <AuthGate
      statut={["etu", "perso"]}
      auto
      deniedMessage={(u) => `Bonjour ${u.prenom} ${u.nom}, tu n'es pas autorisé à te connecter ici.`}
    >
      {(user) => (user.statut === "perso" ? <Controle /> : <ScanForm />)}
    </AuthGate>
  );
  return (
    <Routes>
      <Route path="/" element={<AuthGate><Dashboard /></AuthGate>} />
      <Route path="/suivi" element={<AuthGate statut="perso"><Suivi /></AuthGate>} />
      <Route path="/emargement/:id" element={scan} />
      <Route path="/:id" element={scan} />
    </Routes>
  );
}

export default App;
